import React from "react";
import {useCallback, useEffect, useRef, useState} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, onDesktop, p, pointer, pt} from "@pg-design/helpers-css";
import {getTextVariantStyleFor} from "@pg-design/text";
import {Text} from "@pg-design/text-module";
import {useIsMounted} from "@pg-mono/hooks";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";

const collapseThreshold = 250;

interface IProps {
    className?: string;
    text: string;
    date: string;
}

export const ArticleCommentItemText = React.memo((props: IProps) => {
    const isMounted = useIsMounted();
    const [isOpened, setIsOpened] = useState(true);
    const textEl = useRef<HTMLDivElement>(null);
    const theme = useTheme();
    useEffect(() => {
        // only mount
        if (textEl.current) {
            if (textEl.current.clientHeight >= collapseThreshold) {
                setIsOpened(false);
            }
        }
    }, []);
    const readMore = useCallback(() => setIsOpened(true), []);

    return (
        <div css={commentItemWrapper}>
            <div css={commentArrow} />

            <div ref={textEl} css={[isMounted && !isOpened && collapsed]}>
                <div css={commentText} dangerouslySetInnerHTML={{__html: props.text}} />
            </div>

            <Text variant="info_txt_3" as="div" color={theme.colors.gray[600]} css={pt(2)}>
                {formatDate(props.date, dateTimeFormat.longDateTime)}
            </Text>

            {isMounted && !isOpened && (
                <a css={pointer} onClick={readMore}>
                    <ShowMoreButton />
                </a>
            )}
        </div>
    );
});

const commentArrow = css`
    position: absolute;
    top: 0;
    left: 2rem;
    width: 3rem;
    height: 3rem;

    background: #fff;
    transform: rotate(-45deg) translateX(0rem);
    z-index: -1;
`;

const commentItemWrapper = css`
    position: relative;
    z-index: 2;
    background-color: #fff;
    ${borderRadius(2)}
    ${elevation(2)};
    ${p(2, 1.5, 2, 1.5)};

    ${onDesktop(p(4, 3, 2, 3))}
    & p {
        margin: 0;
    }
`;

const commentText = (theme: Theme) => css`
    margin: 0;
    color: ${theme.colors.secondary};
    ${getTextVariantStyleFor("info_txt_1")(theme)};
`;

const collapsed = css`
    position: relative;
    max-height: 250px;
    overflow: hidden;

    &:after {
        content: "";
        background: linear-gradient(rgba(255, 255, 255, 0) 0, #fff 100%);
        height: 50px;
        position: absolute;
        display: block;
        width: 100%;
        left: 0;
        right: 0;
        bottom: 0;
    }
`;
import React from "react";
import {useCallback, useEffect, useRef, useState} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, onDesktop, p, pointer, pt} from "@pg-design/helpers-css";
import {getTextVariantStyleFor} from "@pg-design/text";
import {Text} from "@pg-design/text-module";
import {useIsMounted} from "@pg-mono/hooks";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";

const collapseThreshold = 250;

interface IProps {
    className?: string;
    text: string;
    date: string;
}

export const ArticleCommentItemText = React.memo((props: IProps) => {
    const isMounted = useIsMounted();
    const [isOpened, setIsOpened] = useState(true);
    const textEl = useRef<HTMLDivElement>(null);
    const theme = useTheme();
    useEffect(() => {
        // only mount
        if (textEl.current) {
            if (textEl.current.clientHeight >= collapseThreshold) {
                setIsOpened(false);
            }
        }
    }, []);
    const readMore = useCallback(() => setIsOpened(true), []);

    return (
        <div css={commentItemWrapper}>
            <div css={commentArrow} />

            <div ref={textEl} css={[isMounted && !isOpened && collapsed]}>
                <div css={commentText} dangerouslySetInnerHTML={{__html: props.text}} />
            </div>

            <Text variant="info_txt_3" as="div" color={theme.colors.gray[600]} css={pt(2)}>
                {formatDate(props.date, dateTimeFormat.longDateTime)}
            </Text>

            {isMounted && !isOpened && (
                <a css={pointer} onClick={readMore}>
                    <ShowMoreButton />
                </a>
            )}
        </div>
    );
});

const commentArrow = css`
    position: absolute;
    top: 0;
    left: 2rem;
    width: 3rem;
    height: 3rem;

    background: #fff;
    transform: rotate(-45deg) translateX(0rem);
    z-index: -1;
`;

const commentItemWrapper = css`
    position: relative;
    z-index: 2;
    background-color: #fff;
    ${borderRadius(2)}
    ${elevation(2)};
    ${p(2, 1.5, 2, 1.5)};

    ${onDesktop(p(4, 3, 2, 3))}
    & p {
        margin: 0;
    }
`;

const commentText = (theme: Theme) => css`
    margin: 0;
    color: ${theme.colors.secondary};
    ${getTextVariantStyleFor("info_txt_1")(theme)};
`;

const collapsed = css`
    position: relative;
    max-height: 250px;
    overflow: hidden;

    &:after {
        content: "";
        background: linear-gradient(rgba(255, 255, 255, 0) 0, #fff 100%);
        height: 50px;
        position: absolute;
        display: block;
        width: 100%;
        left: 0;
        right: 0;
        bottom: 0;
    }
`;
